import React, { useRef, useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import '../styles/SeonaidScratch.css';

const SeonaidScratch = ({ onComplete }) => {
  const canvasRef = useRef(null);
  const [showButton, setShowButton] = useState(false);
  const isDrawing = useRef(false);

  const calcScratched = useCallback(() => {
    const canvas = canvasRef.current;
    if (!canvas) return 0;
    const ctx = canvas.getContext('2d');
    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let cleared = 0;
    for (let i = 3; i < data.length; i += 4) {
      if (data[i] === 0) cleared++;
    }
    return cleared / (data.length / 4);
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setShowButton(true), 5000);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const dpr = window.devicePixelRatio || 1;
    const rect = canvas.getBoundingClientRect();
    canvas.width = rect.width * dpr;
    canvas.height = rect.height * dpr;
    const ctx = canvas.getContext('2d');
    ctx.scale(dpr, dpr);
    ctx.fillStyle = '#2a2a35';
    ctx.fillRect(0, 0, rect.width, rect.height);
    ctx.font = 'italic 18px Playfair Display, serif';
    ctx.fillStyle = 'rgba(155,142,196,0.4)';
    ctx.textAlign = 'center';
    ctx.fillText('Scratch me', rect.width / 2, rect.height / 2 + 6);
  }, []);

  const scratch = useCallback((x, y) => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    ctx.globalCompositeOperation = 'destination-out';
    ctx.beginPath();
    ctx.arc(x, y, 28, 0, Math.PI * 2);
    ctx.fill();
    const pct = calcScratched();
    if (pct >= 0.60 && !showButton) {
      setShowButton(true);
    }
  }, [calcScratched, showButton]);

  const getPos = (e) => {
    const canvas = canvasRef.current;
    const rect = canvas.getBoundingClientRect();
    const touch = e.touches ? e.touches[0] : e;
    return { x: touch.clientX - rect.left, y: touch.clientY - rect.top };
  };

  const handleStart = (e) => { isDrawing.current = true; const p = getPos(e); scratch(p.x, p.y); };
  const handleMove = (e) => { if (!isDrawing.current) return; e.preventDefault(); const p = getPos(e); scratch(p.x, p.y); };
  const handleEnd = () => { isDrawing.current = false; };

  return (
    <motion.div
      className="seonaid-scratch-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
    >
      <div className="seonaid-scratch-card">
        <div className="seonaid-reveal">
          <span className="seonaid-finger">&#x1F595;</span>
        </div>
        <canvas
          ref={canvasRef}
          className="seonaid-canvas"
          onMouseDown={handleStart}
          onMouseMove={handleMove}
          onMouseUp={handleEnd}
          onMouseLeave={handleEnd}
          onTouchStart={handleStart}
          onTouchMove={handleMove}
          onTouchEnd={handleEnd}
        />
      </div>
      <AnimatePresence>
        {showButton && (
          <motion.button
            className="seonaid-continue"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            onClick={onComplete}
          >
            Continue
          </motion.button>
        )}
      </AnimatePresence>
    </motion.div>
  );
};

export default SeonaidScratch;
